export const TimeOut = 100000;
export const AppInfo = {
    title: "Devextreme Vue3",
};